import {Location} from 'vue-router';
import {IHelpdeskTicket} from '@/store/modules/helpdeskTicketsModule';

// The inbox opens the email in ?email= when it loads and whenever that query changes.
export const INBOX_EMAIL_QUERY = 'email';

export function inboxEmailRoute(emailId: number): Location {
  return {name: 'helpdeskInbox', query: {[INBOX_EMAIL_QUERY]: String(emailId)}};
}

// Reporter first (manually created tickets have no linked emails), then each distinct sender.
export function ticketRelatedEmails(ticket: IHelpdeskTicket | null): string[] {
  if (!ticket) return [];

  const candidates: string[] = [ticket.reporter_email || ''];
  (ticket.emails || []).forEach((e) => candidates.push(e.from_email || ''));

  const seen: {[k: string]: boolean} = {};
  const result: string[] = [];
  candidates.forEach((raw) => {
    const email = raw.trim();
    const key = email.toLowerCase();
    if (email && !seen[key]) {
      seen[key] = true;
      result.push(email);
    }
  });
  return result;
}
